const pictureFormats = [ 'gif', 'jpg', 'jpeg', 'png', 'webp' ];

const defaultFallbackFormat = 'png';

const pictureFormatRegex = new RegExp(`\\.(${pictureFormats.join('|')})$`, 'i');

export const hasWebpVersion = (url: string) => {
    const isMacuUrl = /^https:\/\/(www|preview)(-dev|-qa)?\.macu\.com/i.test(url) || url.startsWith('/') || url.startsWith(process.env.GATSBY_MEDIA_URL);
    return isMacuUrl && pictureFormatRegex.test(url);
}

export const getWebpUrl = (url: string) => {
    let webpUrl = url;

    if (hasWebpVersion(url)) {
        webpUrl = url.replace(pictureFormatRegex, '.webp');
    }

    return webpUrl.replace(/ /g, '%20');
}

export const getFallbackUrl = (url: string) => {
    let fallbackUrl = url;

    if (hasWebpVersion(url) && /\.webp$/i.test(url)) {
        fallbackUrl = url.replace(/\.webp$/i, `.${defaultFallbackFormat}`);
    }

    return fallbackUrl.replace(/ /g, '%20');
}

export const getWebpBackgroundImage = (url:string) => {
    return `
        background-image: url(${url});
        background-image: -webkit-image-set(
            url(${getWebpUrl(url)}) 1x,
            url(${url}) 1x
        );
        background-image: image-set(
            url(${getWebpUrl(url)}) 1x,
            url(${url}) 1x
        )
    `;
}